import {
  Component,
} from "react";
import {
  Link,
} from "react-router-dom";
import {
  withLocation,
} from "CommonCore/router-util";
import DocumentTitle from "App/legacy/document-title";

import store from "CommonState/store";
import ContextHelpButton from "Components/context-help";

import _ from "lodash";

@store
export default class Breadcrumb extends Component {
  componentDidMount() {
    this.update(this.props);
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(this.props, prevProps)) {
      setTimeout(() => this.update(this.props));
    }
  }

  componentWillUnmount() {
    this.props.popBreadcrumbLocation(this._key);
  }

  update(props) {
    let {
      data,
      path,
      title,
    } = props;
    const {
      route,
      name,
      hide,
    } = props;

    if (route) {
      path = route.path;
    }
    if (!data) {
      data = [{ name, path, hide }];
    }
    if (!title) {
      title = data[data.length - 1].name;
    }

    if (_.isUndefined(this._key)) {
      this._key = props.pushBreadcrumbLocation(data, title);
    } else {
      props.updateBreadcrumbLocation(data, title, this._key);
    }
  }

  render() {
    return null;
  }
}

@store("breadcrumbs")
@withLocation
export class BreadcrumbRenderer extends Component {
  render() {
    const { breadcrumbs = [], titleFormat, defaultTitle, location } = this.props;
    const path = _.flatten(_.map(breadcrumbs, x => x && x.breadcrumb)).filter(_.identity);
    if (_.some(path, b => b.hide)) {
      return null;
    }
    const { title = defaultTitle } = _.findLast(breadcrumbs, _.identity) || {};
    return <div>
      <DocumentTitle title={_.template(titleFormat)({ title })} />
      <h1 className='page-heading'>
        {title}
        <ContextHelpButton location={location} />
      </h1>
      {path.length > 1 &&
                <ol className='breadcrumb'>
                  {path.map((b, i) => {
                    const last = i === path.length - 1;
                    return <li key={i} className={last ? "active" : ""}>{!last && b.path ? <Link key={i} to={b.path}>{b.name}</Link> : b.name}</li>;
                  })}
                </ol>}
    </div>;
  }
}
